export const PRIMARY_PATIENT_ID = "ae01ceca-3450-4477-a525-667817f3f57b";
export const PRIMARY_PATIENT_NAME = "Henrique Ruicherlei de Santana Fernandes";
export const CLINICAL_WINDOW_START = "2026-08-01T00:00:00-03:00";
export const CLINICAL_WINDOW_END = "2026-10-01T00:00:00-03:00";

export function inClinicalWindow(value?: string | null) {
  if (!value) return false;
  const time = new Date(value).getTime();
  return time >= new Date(CLINICAL_WINDOW_START).getTime() && time < new Date(CLINICAL_WINDOW_END).getTime();
}
